import React from 'react';

const ResourceUtilization = () => {
  return (
    <div className="bg-white p-4 rounded-lg shadow">
      <h3 className="text-lg font-medium mb-3">Resource Utilization</h3>
      
      <div className="grid grid-cols-5 gap-1 mb-3">
        <div className="h-8 bg-blue-500"></div>
        <div className="h-8 bg-blue-500"></div>
        <div className="h-8 bg-blue-500"></div>
        <div className="h-8 bg-blue-300"></div>
        <div className="h-8 bg-blue-100"></div>
        
        <div className="h-8 bg-blue-500"></div>
        <div className="h-8 bg-blue-500"></div>
        <div className="h-8 bg-blue-300"></div>
        <div className="h-8 bg-blue-100"></div>
        <div className="h-8 bg-blue-100"></div>
        
        <div className="h-8 bg-blue-500"></div>
        <div className="h-8 bg-blue-300"></div>
        <div className="h-8 bg-blue-300"></div>
        <div className="h-8 bg-blue-500"></div>
        <div className="h-8 bg-blue-100"></div>
      </div>
      
      <div className="space-y-1 text-sm">
        <div className="flex justify-between">
          <span>Utilization:</span>
          <span className="font-medium">84%</span>
        </div>
        <div className="flex justify-between">
          <span>Underused:</span>
          <span className="font-medium">Room 3</span>
        </div>
      </div>
    </div>
  );
};

export default ResourceUtilization;